import { onMounted, onUnmounted, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3af83367"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "player_container"
};
const _hoisted_2 = {
  class: "player"
};
const _hoisted_3 = {
  class: "headerImg"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "copilot_video",
  class: "video"
}, null, -1));
import LottieView from '@/components/lottieView.vue';
import lottieJson from '../../../../public/animationData/loading/avatar.json';
import bus from '@/utils/mitt.js';
import { digitalHeartBeat } from '@/utils/data.js';
import roleHooks from '@/hooks/roleHooks';
import { useRoute } from 'vue-router';
import env from '@/env';
import TRTC from 'trtc-js-sdk';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['connectError'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    onMounted(() => {
      checkCondition();
      window.addEventListener('beforeunload', function (event) {
        destroy();
      });
      window.addEventListener('onunload', function (event) {
        destroy();
      });
      bus.on('stopChat', stopChat);
    });
    onUnmounted(() => {
      destroy();
    });
    const route = useRoute();
    const {
      curSelectRoleInfo,
      curDigitalInfo,
      showAvatar
    } = roleHooks();
    const mvideo = ref();
    //抠图
    const video = ref(null);
    const c2 = ref(null);
    let websocket = null;
    let wsStaus = ref(false);
    let isPlaying = ref(false);
    let showHeaderImg = ref(false);
    const webglCut = window.webglCut;
    const stopChat = () => {
      if (showAvatar.value) {
        var _client, _digitalHeart, _websocket;
        (_client = client) === null || _client === void 0 ? void 0 : _client.leave();
        (_digitalHeart = digitalHeart) === null || _digitalHeart === void 0 ? void 0 : _digitalHeart.close();
        (_websocket = websocket) === null || _websocket === void 0 ? void 0 : _websocket.close();
        initWebsocket();
      }
    };
    // 校验环境
    const checkCondition = () => {
      if ('WebSocket' in window) {
        initWebsocket();
      } else {
        ElMessage.error('当前浏览器不支持websocket连接');
      }
    };
    const destroy = () => {
      var _websocket2;
      (_websocket2 = websocket) === null || _websocket2 === void 0 ? void 0 : _websocket2.close();
    };
    const initWebsocket = cb => {
      const url = env.AVATARURL;
      const socket = new WebSocket(url);
      socket.onopen = res => {
        console.log('建立websocket-avatar', res, socket);
        websocket = socket;
        wsStaus.value = false;
        cb && cb();
      };
      socket.onmessage = res => {
        if (res.data == 'ppg-end') {
          console.log('ppg-end');
        } else if (res.data == 'ready_to_finish') {
          isPlaying.value = false;
          console.log('ready_to_finish');
          let myCopilotPlayerDom = document.getElementById('copilot_video');
          //添加class fade-out
          myCopilotPlayerDom && myCopilotPlayerDom.classList.add('fade-out');
          // wsStaus = false
        } else if (res.data == 'requests overload') {
          emits('connectError', 'overload');
          console.error('requests overload', res.data);
          wsStaus.value = false;
        } else if (typeof res.data != 'object') {
          const obj = JSON.parse(res.data);
          if (obj.type == 'server_ready') {
            var _digitalHeart2;
            console.log('可以发送语音文件', obj);
            wsStaus.value = true;
            digitalHeart = digitalHeartBeat(websocket);
            (_digitalHeart2 = digitalHeart) === null || _digitalHeart2 === void 0 ? void 0 : _digitalHeart2.setStatus(false);
            initTrtc(obj);
          } else if (obj.type == 'server_paused') {
            console.log('server_paused');
          } else if (obj.type == 'server_ended') {
            var _digitalHeart3;
            let myCopilotPlayerDom = document.getElementById('copilot_video');
            //移除class fade-out
            myCopilotPlayerDom && myCopilotPlayerDom.classList.remove('fade-out');
            console.log('server_ended');
            wsStaus.value = false;
            (_digitalHeart3 = digitalHeart) === null || _digitalHeart3 === void 0 ? void 0 : _digitalHeart3.close();
          } else if (obj.type == 'server_canceled') {
            console.log('server_canceled');
          } else if (obj.type == 'server_exit') {
            emits('connectError', 'exit');
            console.log('server_exit');
          }
        }
      };
      socket.onclose = res => {
        // debugger
        if (res.code != 1000) {
          showAvatar.value && emits('connectError', 'close');
        } else {
          playEnd();
        }
        console.log('websocket-avatar关闭：', res);
        wsStaus.value = false;
      };
      socket.onerror = res => {
        emits('connectError', res);
        console.error('websocket-avatar错误：', res);
        wsStaus.value = false;
      };
    };
    let client = null;
    const enableAutoPlayCb = stream => {
      ElMessageBox.alert('请点击确定继续播放', '提示', {
        confirmButtonText: '确定',
        callback: () => {
          stream.resume();
        }
      });
    };
    const initTrtc = obj => {
      if (!client) {
        client = TRTC.createClient({
          mode: 'rtc',
          sdkAppId: obj.sdkappid,
          userId: obj.userid,
          userSig: obj.usersig,
          useStringRoomId: true,
          enableAutoPlayDialog: !enableAutoPlayCb
        });
      }
      // 加入房间
      client.join({
        roomId: obj.roomid
      }).then(() => {
        console.log('加入房间成功');
      }).catch(err => {
        console.error('加入房间失败', err);
      });
      // 监听远程视频流的添加事件
      client.on('stream-added', event => {
        const remoteStream = event.stream;
        console.log('远端流增加: ' + remoteStream.getId());
        // 订阅远程视频流
        client.subscribe(remoteStream, {
          video: true,
          audio: true
        });
      });
      let isResume = false;
      // 监听远程视频流的订阅事件
      client.on('stream-subscribed', event => {
        const remoteStream = event.stream;
        console.log('远端流订阅成功：' + remoteStream.getId());
        // 创建播放容器
        remoteStream.play('copilot_video');
        isPlaying.value = true;
        remoteStream.on('error', error => {
          const errorCode = error.getCode();
          if (errorCode === 0x4043) {
            // PLAY_NOT_ALLOWED,引导用户手势操作并调用 stream.resume 恢复音视频播放
            // stream.resume()
            if (!isResume) {
              enableAutoPlayCb(remoteStream);
              isResume = true;
              setTimeout(() => {
                isResume = false;
              }, 200);
            }
            return;
          }
          playEnd();
        });
      });
      // 创建客户端对象
      client.on('stream-removed', async event => {
        console.log('远端流删除');
        playEnd();
        try {
          await client.leave();
        } catch (error) {}
      });
      return client;
    };
    const playEnd = () => {
      console.log('播放结束');
      isPlaying.value = false;
      bus.emit('flvEnd', true);
    };
    // 启动 ws 指令
    const sendStart = ws => {
      var _websocket3;
      console.log('ws.send start !', ws.readyState);
      if (((_websocket3 = websocket) === null || _websocket3 === void 0 ? void 0 : _websocket3.readyState) != 1) {
        initWebsocket(() => {
          sendStart(websocket);
        });
        return;
      }
      const signal = JSON.stringify({
        signal: 'start',
        input_format: 'audio/x-wav;codec=pcm;bit=16;rate=16000',
        output_format: 'flv',
        msg_id: '123',
        source: 'test',
        speaker: curDigitalInfo.value.speakerId,
        transfer_type: 'trtc'
      });
      ws === null || ws === void 0 ? void 0 : ws.send(signal);
    };
    const sendPause = ws => {
      console.log('ws.send pause !');
      const signal = JSON.stringify({
        signal: 'pause'
      });
      ws === null || ws === void 0 ? void 0 : ws.send(signal);
    };
    const sendEnd = ws => {
      console.log('ws.send end !');
      const signal = JSON.stringify({
        signal: 'end'
      });
      ws === null || ws === void 0 ? void 0 : ws.send(signal);
    };
    bus.on('reConnect', () => {
      initWebsocket();
    });
    bus.on('sendStatus', status => {
      if (status == 'start') {
        sendStart(websocket);
      } else {
        let timer = setInterval(() => {
          var _digitalHeart4;
          if (((_digitalHeart4 = digitalHeart) === null || _digitalHeart4 === void 0 ? void 0 : _digitalHeart4.getBlobList()) == 0) {
            var _digitalHeart5;
            clearInterval(timer);
            (_digitalHeart5 = digitalHeart) === null || _digitalHeart5 === void 0 ? void 0 : _digitalHeart5.setStatus(true);
            sendEnd(websocket);
          }
        }, 40);
      }
    });
    // audio数据传入
    let digitalHeart = null;
    const audioBlob = blob => {
      if (websocket && wsStaus.value) {
        if (blob instanceof Array) {
          var _digitalHeart6;
          (_digitalHeart6 = digitalHeart) === null || _digitalHeart6 === void 0 ? void 0 : _digitalHeart6.inputBlod(blob);
        } else {
          var _digitalHeart7;
          (_digitalHeart7 = digitalHeart) === null || _digitalHeart7 === void 0 ? void 0 : _digitalHeart7.inputBlod([blob]);
        }
      }
    };
    expose({
      audioBlob
    });
    return (_ctx, _cache) => {
      return _unref(showAvatar) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(LottieView, {
        class: "lottie",
        autoplay: true,
        loop: true,
        jsonData: _unref(lottieJson),
        assetsPath: "/animationData/loading/images/"
      }, null, 8, ["jsonData"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: _unref(curSelectRoleInfo).gifUrl,
        alt: ""
      }, null, 8, _hoisted_4)]), _hoisted_5])])) : _createCommentVNode("", true);
    };
  }
});